import { mapActions, mapState } from 'pinia';
import {
  useEditorStore,
} from '@/stores';
import * as types from '@/lib/constants/store';
import { validateTEI } from '@/lib/utils/tei';

export default {
  computed: {
    ...mapState(useEditorStore, [
      'teiErrors',
    ]),
    validationError() {
      // This is the TEI validation error shown in the template. It's stored in Pinia
      // rather than in local data so it's possible for the rest of the app to know whether
      // there are TEI changes that haven't been saved yet due to validation errors
      return this.teiErrors[this.moduleData.id];
    },
  },
  beforeUnmount() {
    this[types.UPDATE_TEI_ERRORS]({
      id: this.moduleData.id,
      error: false,
    });
  },
  methods: {
    ...mapActions(useEditorStore, [
      types.UPDATE_MODULE,
      types.UPDATE_TEI_ERRORS,
    ]),
    validateAndUpdateTEI() {
      try {
        validateTEI(this.clonedModuleData);
        this[types.UPDATE_MODULE]({
          canvasName: this.canvasName, // prop available in all module components
          payload: this.clonedModuleData, // supplied by the moduleData mixin
        });

        this[types.UPDATE_TEI_ERRORS]({
          id: this.moduleData.id,
          error: false,
        });
      } catch (e) {
        this[types.UPDATE_TEI_ERRORS]({
          id: this.moduleData.id,
          error: e,
        });
      }
    },
  },
};
